import { getEmailCampaignIdForEvent } from './utils/emailCampaignAttribution.js';

export function makeProductVariant({
  id,
  productTitle = '',
  pid,
  photo,
  attendeeUId,
  eventName,
  imgUrl,
  productPurpose,
  product_purpose,
  printPool,
  shippingPrintPool,
  partialUnlockTags,
  pipelineTag,
  assetTag,
  pipeline_tag,
  asset_tag,
}) {
  if (!id && id !== 0) throw new Error('Should be id');
  if (!pid && pid !== 0) throw new Error('Should be pid');
  const purpose = productPurpose ?? product_purpose;
  const resolvedPipelineTag = pipelineTag ?? pipeline_tag;
  const resolvedAssetTag = assetTag ?? asset_tag;
  const resultVariant = {
    id,
    productTitle,
    pid,
    imgUrl,
    attendeeUid: attendeeUId,
    eventName,
    productPurpose: purpose,
  };
  // Read directly rather than threaded through every caller (like attendeeUId/eventName are) —
  // it's a whole-visit attribution value, not something that varies per product/variant, so
  // every line item in the order picks up the same tag automatically. Set by new-appPages.js
  // when a campaign email link is the entry point, scoped to that event so a later visit to
  // a different gallery cannot inherit it.
  const emailCampaignId = getEmailCampaignIdForEvent(eventName);
  if (emailCampaignId) {
    resultVariant.emailCampaignId = emailCampaignId;
  }
  if (purpose === 'printable' || purpose === 'partial_unlock_media') {
    resultVariant.photoId = photo?.id || '';
    resultVariant.occoImgUrl = photo?.thumb_full_path || '';
  }
  if (purpose === 'printable') {
    resultVariant.poolName = printPool;
    resultVariant.shippingPrintPool = shippingPrintPool;
  }
  if (purpose === 'partial_unlock_tags') {
    resultVariant.partialUnlockTags = partialUnlockTags;
  }
  if (purpose === 'trigger_pipeline' && resolvedPipelineTag && resolvedAssetTag) {
    resultVariant.pipelineTag = resolvedPipelineTag;
    resultVariant.assetTag = resolvedAssetTag;
  }
  return resultVariant;
}

export function makeProductsData({
  id,
  productTitle,
  anotherProductsId,
  imgUrl,
  eventName,
  attendeeUId,
  printPool,
  productPurpose,
  partialUnlockTags,
  variantId,
  shippingPrintPool,
  dTags,
  rTags,
  pipelineTag,
  assetTag,
}) {
  if (!id && id !== 0) throw new Error('Should be id');

  const variant = {
    id,
    productTitle,
    anotherProductsId,
    imgUrl,
    printPool,
    attendeeUId,
    eventName,
    productPurpose,
    partialUnlockTags,
    variantId,
    shippingPrintPool,
    pipelineTag,
    assetTag,
    tagsFilter: prepareTagsFilter(dTags, rTags),
  };

  variant.poolName = printPool;
  variant.shipmentPoolPrefix = shippingPrintPool;
  return variant;
}

export function getPidList(productsData, selectedPhotos) {
  if (productsData.anotherProductsId === Infinity) return selectedPhotos.map((_, i) => i);
  return productsData.anotherProductsId;
}

function prepareTagsFilter(dTags, rTags) {
  const acceptTags = rTags ? rTags.split(',').map((tag) => tag.trim()) : [];
  const denyTags = dTags ? dTags.split(',').map((tag) => tag.trim()) : [];
  return { acceptTags, denyTags };
}

export function makeLineItem({ variantId, variantArr }) {
  return {
    variantId,
    quantity: 1,
    customAttributes: [
      {
        key: '_variantArr',
        value: JSON.stringify(variantArr),
      },
    ],
  };
}
